export default __webpack_public_path__ + "static/media/fold_cover.348a9a0e.png";